import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

// This component was originally used to display the notification banners throughout the app.
// However, the notification banners have been moved to only the dashboard. We'll keep this component
// in case any component should be displayed throughout the app.
@Component({
  selector: 'app-app-container',
  templateUrl: './app-container.component.html',
  styleUrls: ['./app-container.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppContainerComponent implements OnInit {
  constructor() {}

  wholeNavIsCollapsed: boolean = false;
  multiNavIsCollapsed: boolean = false;

  ngOnInit(): void {}
}
